import React, { useEffect, useState } from "react";
import { Card, Accordion } from "react-bootstrap";
import Select from "react-dropdown-select";
import CustomDropdown from "../CustomDropdown";
import CustomControl from "../CustomControl";
import SelectedMotorizedStep9Pleated from "../SelectedMotorizedStep9Pleated";

export default function Step9PleatedOne({
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step6A,
  step5,
  step3A0,
  step2B,
  step2A,
  widthCart,
  modalHandleShow,
  NextStep,
  step8,
  setStep81,
  setStep82,
  setStep83,
  setStep9ADrapery,
  setStep8B,
  setStep8C,
  setSelectedDrapery,
  setSelectedSheer,
  setSelectedPrivacyLayer,
  extendedTitle,
  step6,
  setHardwareNextStep,
  setStep8,
  selectUncheck,
  setDeps,
  setCart,
  setExtendedTitle,
  selectChanged,
  inputs,
  step6BHead,
  step3,
  step31,
  step2B1,
  step2C,
  pageLanguage,
  privacyLayerSelect,
  step6CHead,
  OverlayContainer,
  rodsList,
  rodsColorList,
  rodsLoad,
  rodsLoad2,
  modelAccessories,
  step81,
  step83,
  GetPrice,
  isTabletOrMobile,
  selectedDrapery,
  pageLoad,
  skipHardwareTypeCartWipeRef,
  draperiesSelect,
  sheersSelect,
  sheersSelect2,
  sheersSelect3,
  selectedSheer,
  selectedPrivacyLayer,
  privacyLayerSelect3,
  privacyLayerSelect2,
  hardwareNextStep,
  step6DHead,
  draperiesSelect2,
  tracksList4,
  rodsColorList5,
  step8D1,
  trackType8B,
  motorErr1,
  step8B6,
  setStep8B6,
  setMotorErr1,
  setSelectedMotorPositionB,
  setSelectedRemoteName,
  setSelectedMotorChannelsB,
  motorChannels,
  setRemoteNameB,
  setShowRemoteName,
  setCartLoading,
  selectedMotorPositionB,
  selectedRemoteName,
  selectedMotorChannelsB,
  remoteNames,
  showRemoteName,
  Capitalize,
  remoteNameB,
  MotorPosition,
  step8B,
  step8B4,
  setStep8B4,
  step8A4,
  setStep8A4,
  setStep8D1,
  setStep8B1,
  setStep8C1,
  setStepTrackCollections9A,
  setStepControl9A,
  setStepHardware9A,
  setStep9APosition,
  step6B,
  step6C,
  draperiesSelect3,
  step6CHead9,
  setStep6CHead9,
  hardwareDraperyStep9,
  hardwareSheerStep9,
  hardwareLayerStep9,
  step8RodCheck,
  step8DTrack,
  setStep8DTrack,
  setStep8RodCheck,
  setStep8BRilType,
  setStep8CTrack,
  setStepTCollections9A,
  setStep8D2,
  windowWidthPanelType
}) {
  let message = "";
  const [shouldApplyTrack, setShouldApplyTrack] = useState(false);
  const [shouldApplyRod, setShouldApplyRod] = useState(false);
  let optionsDrapery;
  let sheerDrapery;
  let layerDrapery;
  let contentToRender;

  const draperyPlaceholder = hardwareDraperyStep9 
  ? privacyLayerSelect[pageLanguage].find(item => item.value === hardwareDraperyStep9)?.label 
  : t("Please Select");
  const draperySheerPlaceholder = hardwareSheerStep9 
  ? privacyLayerSelect[pageLanguage].find(item => item.value === hardwareSheerStep9)?.label 
  : t("Please Select");
  const draperyLayerPlaceholder = hardwareLayerStep9 
  ? privacyLayerSelect[pageLanguage].find(item => item.value === hardwareLayerStep9)?.label 
  : t("Please Select");

  if (step3A0 === "") {
    message = t("panel_type_text1_hardware");
  } else if (step3 === "") {
    message = t("panel_type_text4_hardware");
  } else if (step5 === "") {
    message = t("panel_type_text6_hardware");
  } else if (step6A === "") {
    message = t("panel_type_text5_hardware");
  } else if (step6B === "") {
    message = t("panel_type_text5_hardware");
  } else if (step2B !== "None") {
    if(step6C === ""){
      message = t("panel_type_text5_hardware");
    }
  }

  useEffect(() => {
    if (
      (step6CHead === "Track" && step6BHead === "Track" && step6DHead === "Track") ||
      (step6CHead === "Rod" && step6BHead === "Rod" && step6DHead === "Rod")
    ) {
      if (step6CHead === "Rod" && step6BHead === "Rod" && step6DHead === "Rod") {
        // After refresh, keep the Step 9 type that was actually restored (rod vs track)
        const restoredRod = !!step81 || (!!step8RodCheck && !["2207", "2208"].includes(`${step8RodCheck}`));
        const restoredTrack =
          !!step8D1 ||
          step8DTrack === "2208" ||
          step8DTrack === "2207" ||
          step8DTrack === "2201" ||
          step8B6 === "true";
        if (restoredRod && !restoredTrack) {
          if (step6CHead9 !== "Rod") {
            setStep6CHead9("Rod");
          }
        } else if (restoredTrack && !restoredRod) {
          if (step6CHead9 !== "Track") {
            if (skipHardwareTypeCartWipeRef) {
              skipHardwareTypeCartWipeRef.current = true;
            }
            setStep6CHead9("Track");
          }
        } else if (
          !skipHardwareTypeCartWipeRef?.current &&
          !pageLoad &&
          !restoredTrack &&
          step6CHead9 !== "Track"
        ) {
          setStep6CHead9("Rod");
        }
      }

      if (step6CHead === "Track" && step6BHead === "Track" && step6DHead === "Track") {
        if (!skipHardwareTypeCartWipeRef?.current && !pageLoad && step6CHead9 !== "Rod") {
          setStep6CHead9("Track");
        }
      }
      if (parseInt(windowWidthPanelType) > 160) {
        if (step3 === "false" && step31 === "" && step6BHead === "Rod") {
          setShouldApplyTrack(true);
        } else if (step3 === "false" && step31 === "" && step6BHead === "Track") {
          setShouldApplyRod(true);
        } else if (step31 === "Track" && step6BHead === "Track" && step3 === "true") {
          setShouldApplyRod(true);
        } else if (step31 === "false" && step6BHead === "Rod" && step3 === "true") {
          setShouldApplyTrack(true);
          setShouldApplyRod(false);
        } else if (step31 === "false" && step6BHead === "Track" && step3 === "true") {
          setShouldApplyRod(true);
          setShouldApplyTrack(false);
        } else if (step31 === "true" && step6BHead === "Rod" && step3 === "true") {
          setShouldApplyTrack(true);
          setShouldApplyRod(false);
        } else if (step31 === "true") {
          setShouldApplyRod(true);
        } else {
          setShouldApplyTrack(false);
          setShouldApplyRod(false);
        }
      } else if (parseInt(windowWidthPanelType) <= 160) {
        if (step31 === "" && step3 === "false") {
          setShouldApplyRod(false);
          setShouldApplyTrack(false);
        } else if (step31 === "true" && step3 === "true" && step6CHead === "Rod") {
          setShouldApplyTrack(true);
        } else if (step31 === "Track" && step3 === "true" && step6CHead === "Track") {
          setShouldApplyRod(true);
        } else {
          setShouldApplyTrack(false);
          setShouldApplyRod(false);
        }
      } else {
        setShouldApplyTrack(false);
        setShouldApplyRod(false);
      }
    }
  }, [step6CHead, step6BHead, step6DHead, step5, step6C, step8D1, step6CHead9, step8DTrack, step8B6, step81, step8RodCheck]);

  useEffect(() => {
    // After refresh, restoring Track must not wipe cart design/color/baton
    if (skipHardwareTypeCartWipeRef?.current) {
      return;
    }
    setCart(
      "Hardware",
      "Same Hardware For All Curtains",
      "hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
      "DraperyHardware,SheerHardware,PrivacyLayerHardware",
      parseInt(windowWidthPanelType) <= 160
        ? [step6CHead9, step6CHead9, step6CHead9]
        : [step6CHead, step6BHead, step6DHead]
    );
  }, [step6CHead9]);



  if (parseInt(windowWidthPanelType) < 160 && step6CHead === "Rod" && step3 === "true" && step31 === "true") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6CHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) < 160 &&
    step6CHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod" && step3 === "false") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step31 === "false" &&
    step6CHead === "Rod" &&
    step3 === "true"
  ) {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6CHead === "Rod" &&
    step31 === "true" &&
    step3 === "true"
  ) {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160) {
    optionsDrapery = privacyLayerSelect3[pageLanguage];
  } else if (step6BHead === "Rod") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  }

  if (parseInt(windowWidthPanelType) < 160 && step6BHead === "Rod" && step3 === "true" && step31 === "true") {
    sheerDrapery = sheersSelect[pageLanguage];
  } else if (
    selectedDrapery &&
    selectedDrapery[0] &&
    (selectedDrapery[0].num === "3" ||
      selectedDrapery[0].num === "4" ||
      selectedDrapery[0].num === "5") &&
    step31 === "false"
  ) {
    sheerDrapery = sheersSelect2[pageLanguage];
  } else if (
    selectedDrapery &&
    selectedDrapery[0] &&
    (selectedDrapery[0].num === "3" ||
      selectedDrapery[0].num === "4" ||
      selectedDrapery[0].num === "5") &&
    parseInt(windowWidthPanelType) < 160 &&
    step31 === "" &&
    step3 === "false"
  ) {
    sheerDrapery = sheersSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) < 160 &&
    step6BHead === "Track" &&
    step3 === "true" &&
    step31 === "true"
  ) {
    sheerDrapery = sheersSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6BHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    sheerDrapery = sheersSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) < 160 &&
    step6BHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    sheerDrapery = sheersSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160 && step31 !== "true" && step3 !== "true") {
    sheerDrapery = sheersSelect3[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160 && step31 === "true" && step3 === "true") {
    sheerDrapery = sheersSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) <= 160 &&
    step6BHead === "Rod" &&
    step31 === "false" &&
    step3 === "true"
  ) {
    sheerDrapery = sheersSelect3[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) <= 160 &&
    step6BHead === "Track" &&
    step31 === "false" &&
    step3 === "true"
  ) {
    sheerDrapery = sheersSelect3[pageLanguage];
  } else if (step6BHead === "Rod") {
    sheerDrapery = sheersSelect[pageLanguage];
  } else {
    sheerDrapery = sheersSelect2[pageLanguage];
  }

  if (parseInt(windowWidthPanelType) < 160 && step6DHead === "Rod" && step3 === "true" && step31 === "true") {
    layerDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    selectedSheer &&
    selectedSheer[0] &&
    (selectedSheer[0].num === "3" ||
      selectedSheer[0].num === "4" ||
      selectedSheer[0].num === "5") &&
    step31 === "false"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    selectedSheer &&
    selectedSheer[0] &&
    (selectedSheer[0].num === "3" ||
      selectedSheer[0].num === "4" ||
      selectedSheer[0].num === "5") &&
    parseInt(windowWidthPanelType) < 160 &&
    step31 === "" &&
    step3 === "false"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6DHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) <= 160 &&
    step6DHead === "Track" &&
    step3 === "true" &&
    step31 === "true"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) < 160 &&
    step6DHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) > 160 && step6DHead === "Track" && step3 === "false") {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step31 === "false" &&
    step6DHead === "Track" &&
    step3 === "true"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6DHead === "Track" &&
    step31 === "true" &&
    step3 === "true"
  ) {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160) {
    layerDrapery = privacyLayerSelect3[pageLanguage];
  } else if (step6DHead === "Rod") {
    layerDrapery = privacyLayerSelect[pageLanguage];
  } else {
    layerDrapery = privacyLayerSelect2[pageLanguage];
  }

 

  if (step6CHead9 === "Track") {
    contentToRender = tracksList4;
  } else if (step6CHead9 === "Rod") {
    contentToRender = rodsList;
  }



  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="8"
          stepNum={step5 === "Full" && step3 === "false" ? t("8") : t("9")}
          stepTitle={t("grommet_step8")}
          stepRef="8"
          type="1"
          required={requiredStep["8"]}
          stepSelected={stepSelectedLabel["8"] === undefined ? "" : stepSelectedLabel["8"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="8">
        <Card.Body>
        <div
  className={
    step6A === "" ||
    step5 === "" ||
    step3A0 === "" ||
    step2B === "" ||
    step6B === "" ||
    (step2B !== "None" ? step6C === "" : false)
      ? "card_body_info_body card_body_info_body_grommet"
      : "noDisplay"
  }
>
            <h1 className="card_body_info_header_title title_step10">{t("more_info")}</h1>
            <hr />
            <div>
              <p className="card_body_info_text card_body_info_text_grommet">
                {message}
                <button
                  className="btn_step10"
                  onClick={() => {
                    modalHandleShow("hardwareCollections");
                  }}
                >
                  {t("Preview our hardware collections.")}
                </button>
              </p>
            </div>
            <NextStep currentStep="6" eventKey="9">
              {t("NEXT STEP")}
            </NextStep>
          </div>
          <div
        className={
         widthCart !== undefined &&
         step5 !== "" &&
         step6A !== "" &&
         step6B !== "" &&
          (step2B === "None" ? true : step6C !== "")
          ? "card-body"
         : "noDisplay"
        }
       >
            <div className="card_body card_body_radio card_body_hardware card_body_hardware3">
              <div className="box-card-hardware-pleated">
              <div className="box50 box51 radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("hardware1")}
                  value="1"
                  name="step8"
                  ref-num="8"
                  id="81"
                  outline="true"
                  checked={step8 === "I Have My Own Hardware"}
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepTCollections9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep8D1("");
                    setStep8DTrack("");
                    setStep8C1("");
                    setStep8CTrack("");
                    setStep8B1("");
                    setStep8BRilType("");
                    setStep81("");
                    setStep8RodCheck("");
                    setStep82("");
                    setStep83("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setSelectedDrapery([]);
                    setSelectedSheer([]);
                    setSelectedPrivacyLayer([]);
                    let tempExtended = extendedTitle;
                    if (step6 === "") {
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noPanelType");
                      setDeps(
                        "8",
                     "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,8P5,8P6,811,812,813,801,848,844,842,849,850,852,853,854,855,856,857,845,846,847"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else if (
                      step2A === "" ||
                      step2B === "" ||
                      (step2B !== "None" && step2B1 === "") ||
                      (step2B !== "None" && step2C === "")
                    ) {
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noPrivacyLayer");
                      setDeps(
                        "8",
                        "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,8P5,8P6,842,843,811,812,813,801,848,844,842,849,850,852,853,854,855,856,857,845,846,847"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else {
                      tempExtended["8"] = [t("None")];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      setExtendedTitle(tempExtended);
                      selectChanged(e, "8A,8B,8C");
                      setStep8("I Have My Own Hardware");
                      setHardwareNextStep("9");
                   
                      if (step2B === "None") {
                        setDeps(
                          "85,86",
                         "8,8A,84,809,810,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,8B,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,87,8C,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                        );
                      } else {
                        setDeps(
                          "85,86,87",
                          "8,8A,84,809,810,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,8B,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,8C,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                        );
                      }
                      setCart(
                        "Hardware",
                        "I Have My Own Hardware",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    }
                  }}
                  ref={(ref) => (inputs.current["81"] = ref)}
                />
                <label htmlFor="81">{t("I Don't Need Any Hardware")}</label>
              </div>
              <div className="box50 box51 radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Same Hardware For All Curtains")}
                  value="2"
                  name="step8"
                  ref-num="8"
                  id="82"
                  outline="true"
                  checked={step8 === "Same Hardware For All Curtains"}
                  disabled={!(step6DHead === step6BHead && step6BHead === step6CHead)}
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepTCollections9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep8B1("");
                    setStep8BRilType();
                    setStep8C1("");
                    setStep8CTrack("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setStep8D1("");
                    setStep8DTrack("");
                    let tempExtended = extendedTitle;
                    if (step3 === "" || (step3 === "true" && step31 === "")) {
                     
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noMeasurements");
                      setDeps(
                        "8A,811,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3",
                        "81,82,83,85,86,87,8A3,8A4,8B3,8B5,8B51,8B6,8C3,8C5,8C51,8C52,8C6,8P5,8P6,842,843,812,813,848,844,842,849,850,852,853,854,855,856,857,845,846,847"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else {
                     
                      selectChanged(e, "8A,8B,8C");
                      setTimeout(() => {
                        setStep8("Same Hardware For All Curtains");
                      }, 300);
                      tempExtended["8"] = [t("Same Hardware For All Curtains")];
                      setHardwareNextStep("9");
                      if(step6CHead9 === "Rod" ){
                        setDeps(
                          "809",
                         "8,8A,85,84,810,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,86,8B,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,87,8C,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                       );
                      }else{
                        setDeps(
                          "810",
                        "8,8A,85,84,809,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,86,8B,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,87,8C,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                       );
                      }
                    
                    
                      setCart(
                        "Hardware",
                        "Same Hardware For All Curtains",
                        "hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware",
                        parseInt(windowWidthPanelType) <= 160
                          ? [step6CHead9, step6CHead9, step6CHead9]
                          : [step6CHead, step6BHead, step6DHead]
                      );
                    }
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["82"] = ref)}
                />
                <label htmlFor="82" className="same_line_extension_unavailable">
                  {t("hardware2")}
                  {!(step6DHead === step6BHead && step6BHead === step6CHead) && (
                    <OverlayContainer
                      classNames="extension_unavailable"
                      placement="bottom"
                      children={
                        <div className="extension_unavailable_title text_underline">
                          {t("Why is this unavailable?")}
                        </div>
                      }
                      component={
                        <div className="extension_unavailable_container">
                          <div className="extension_unavailable_text">
                            {t("rod_track_hardware_text")}
                          </div>
                        </div>
                      }
                    />
                  )}
                </label>
              </div>
              <div className="box50 box51 radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Customize Hardware Per Curtain")}
                  value="3"
                  name="step8"
                  ref-num="8"
                  id="83"
                  outline="true"
                  checked={step8 === "I Want To Customize Hardware Per Curtain"}
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepTCollections9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep81("");
                    setStep8RodCheck("");
                    setStep82("");
                    setSelectedDrapery([]);
                    setStep83("");
                    setStep8B1("");
                    setStep8BRilType("");
                    setStep8C1("");
                    setStep8CTrack("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setStep8D1("");
                    setStep8DTrack("");
                    let tempExtended = extendedTitle;
                    if (
                      step2A === "" ||
                      step2B === "" ||
                      (step2B !== "None" && step2B1 === "") ||
                      (step2B !== "None" && step2C === "")
                    ) {
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noPrivacyLayer");
                      setDeps(
                        "8",
                        "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,8P5,8P6,842,843,811,812,813,811,848,844,842,849,850,852,853,854,855,856,857,845,846,847"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else {
                      setHardwareNextStep("8A");
                      selectChanged(e, "8A,8B,8C");
                      setStep8("I Want To Customize Hardware Per Curtain");
                      tempExtended["8"] = [t("Customize Hardware Per Curtain")];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      
                      if (step2B === "None") {
                        setDeps(
                          "8A,8B",
                          "8,85,84,809,810,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,86,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,87,8C,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                        );
                      } else {
                        setDeps(
                          "8A,8B,8C",
                         "8,85,84,809,810,811,812,813,8A1,8A2,8A3,8C3,8A4,8C5,8P5,8P6,814,842,843,844,845,846,847,848,86,8B1,8B2,8B3,8B5,8B51,8B6,849,850,852,853,854,855,856,857,87,8C1,8C2,8C51,8C52,8C6,858,859,860,861,862,863,864,865"
                        );
                      }
                      setCart(
                        "Hardware",
                        "I Want To Customize Hardware Per Curtain",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer"
                      );
                    }
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["83"] = ref)}
                />
                <label htmlFor="83">{t("hardware3")}</label>
              </div>
              </div>

              {/* step 10 Questions */}

              <div
                className={
                  step5 !== "" && step8 === "Same Hardware For All Curtains"
                    ? "card_body card_body_radio card_body_Rod"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title">{t("Hardware Type")}</p>
                </div>
                <div
                  className={
                    step5 !== "" && step8 === "Same Hardware For All Curtains"
                      ? "grommet_curtain_button_container"
                      : "noDisplay"
                  }
                >
                  
                  <div className="dk_curtain_symmetric_buttons">
                    <button
                      className={`dk_curtain_symmetric_button_left btn ${shouldApplyRod ? "crossed" : ""}
                      ${step6CHead9 === "Rod" ? "dk_curtain_symmetric_button_on" : ""} 
                        `}
                      onClick={() => {
                        if (skipHardwareTypeCartWipeRef) {
                          skipHardwareTypeCartWipeRef.current = false;
                        }
                        setStep6CHead9("Rod");
                        setStep8D1("");
                        setStep8DTrack("");
                        setStep8B6("");
                          setDeps("809", "8A2,8A3,8P5,8P6,8C5,812,813,8A1,8A,,85,811,8C3,8P5,84,842,843,812,813,801,848,844,842,801,8B,8C,810");
                          setStep8B4("");
                         setStep8D2("");
                        setStep8A4("");
                        setStep82("");
                      }}
                    >
                      {t("Rod")}
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6CHead9 === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      }  ${shouldApplyTrack ? "crossed" : ""} `}
                      onClick={() => {
                        if (skipHardwareTypeCartWipeRef) {
                          skipHardwareTypeCartWipeRef.current = false;
                        }
                        setStep6CHead9("Track");
                        setStep81("");
                        setStep8RodCheck("");
                          setDeps("810", "8A2,8A3,8P5,8P6,8C5,812,813,8A1,8A,,85,811,8C3,8P5,84,842,843,812,813,801848,844,842,801,8B,8C,809,811");
                     
                        setStep8A4("");
                        setStep82("");
                      }}
                    >
                      {t("Track")}
                    </button>
                  </div>
                 
                </div>
              </div>
             <div 
               className={
                step8 === "Same Hardware For All Curtains"
                  ? "box_rod-collection"
                  : "noDisplay"
              }>
             <div className="box100">
                  <p className="step_selection_title2">
                  {step6CHead9 === "Rod" ? t("Rod Collection") : t("Track Collection")} 
                    </p>
                  </div>
             </div>
              <div
                className={
                  step8 === "Same Hardware For All Curtains"
                    ? "card_body card_body_radio card_body_Rod card_body_radio card_body_Rod2 card-body-rod-collection-drapery"
                    : "noDisplay"
                }
              >
                {contentToRender}
              </div>

              <div
                className={
                  step8 === "Same Hardware For All Curtains" && (step8DTrack !== "" || step8RodCheck !== "") 
                    ? "card_body card_body_radio card_body_Rod_color"
                    : "noDisplay"
                }
              >
                <div className={`box100 ${step8DTrack === "2208" ? "noDisplay" : ""}`}>
                  <p className="step_selection_title">{t("step8_rod_finish_title")}</p>
                </div>
                {step6CHead9 === "Rod" ? (
  rodsColorList
) : step6CHead9 === "Track" && (!step8DTrack || step8DTrack !== "2208") ? (
  rodsColorList5
) : (
  <SelectedMotorizedStep9Pleated
    trackType8B={trackType8B}
    motorErr1={motorErr1}
    t={t}
    step8B6={step8B6}
    selectChanged={selectChanged}
    setStep8B6={setStep8B6}
    setMotorErr1={setMotorErr1}
    setSelectedMotorPositionB={setSelectedMotorPositionB}
    setSelectedRemoteName={setSelectedRemoteName}
    setSelectedMotorChannelsB={setSelectedMotorChannelsB}
    motorChannels={motorChannels}
    pageLanguage={pageLanguage}
    setRemoteNameB={setRemoteNameB}
    setDeps={setDeps}
    setCart={setCart}
    selectUncheck={selectUncheck}
    inputs={inputs}
    modalHandleShow={modalHandleShow}
    selectedMotorPositionB={selectedMotorPositionB}
    selectedRemoteName={selectedRemoteName}
    selectedMotorChannelsB={selectedMotorChannelsB}
    remoteNames={remoteNames}
    showRemoteName={showRemoteName}
    Capitalize={Capitalize}
    pageLoad={pageLoad}
    rodsLoad={rodsLoad}
    rodsLoad2={rodsLoad2}
    remoteNameB={remoteNameB}
    MotorPosition={MotorPosition}
    setShowRemoteName={setShowRemoteName}
    setCartLoading={setCartLoading}
    extendedTitle={extendedTitle}
  />
)
}
              </div>

             

              <div
                className={
                  step8 === "Same Hardware For All Curtains" && step8DTrack === "2201"
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title">{t("Baton Option")}</p>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("None")}
                    value="1"
                    name="step83"
                    ref-num="8"
                    id="831"
                    checked={step83 === "None"}
                    onChange={(e) => {
                      setStep83("None");
                      setDeps("", "8A,8A1,8A3,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(
                        undefined,
                        undefined,
                        "",
                        "BatonOptionA,BatonOptionB,ControlPositionB,BatonOptionC,ControlPositionC",
                        ["None", "None", "None"]
                      );
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("None")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["831"] = ref)}
                  />
                  <label htmlFor="831">{t("None")}</label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 30cm")}
                    value="2"
                    name="step83"
                    ref-num="8"
                    id="832"
                    checked={step83 === "Baton 30cm"}
                    onChange={(e) => {
                      setStep83("Baton 30cm");
                      setDeps("", "8A,8A1,8A3,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(undefined, undefined, "", "BatonOptionA,BatonOptionB,BatonOptionC", [
                        "Baton 30cm",
                        "Baton 30cm",
                        "Baton 30cm",
                      ]);
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 30cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["832"] = ref)}
                  />
                  <label htmlFor="832">
                    {t("Baton 30cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["58"]
                          ? GetPrice(
                              modelAccessories["27"]["58"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 45cm")}
                    value="3"
                    name="step83"
                    ref-num="8"
                    id="833"
                    checked={step83 === "Baton 45cm"}
                    onChange={(e) => {
                      setStep83("Baton 45cm");
                      setDeps("", "8A,8A1,8A3,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(undefined, undefined, "", "BatonOptionA,BatonOptionB,BatonOptionC", [
                        "Baton 45cm",
                        "Baton 45cm",
                        "Baton 45cm",
                      ]);
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 45cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["833"] = ref)}
                  />
                  <label htmlFor="833">
                    {t("Baton 45cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["59"]
                          ? GetPrice(
                              modelAccessories["27"]["59"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
               
              </div>

              <div
                className={
                  step8 === "I Have My Own Hardware"
                    ? "card_body card_body_radio card_body_have_hardware"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title">{t("step8_haveHardware_title")}</p>
                </div>
                <div className="box50 radio_style">
                  <div className="same_row_selection_title">{t("Drapery Hardware")}</div>
                </div>
                <div className="box50 radio_style">
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={draperyPlaceholder}
                      portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedDrapery}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdown props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setCart("hardwareDrapery", selected[0].value);
                          setDeps("", "85", 1);
                          let tempExtended = extendedTitle;
                          tempExtended["8"][1] = (
                            <li key="1" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Drapery Hardware")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                              </span>
                            </li>
                          );
                          setExtendedTitle(tempExtended);
                          setSelectedDrapery(selected);
                        }
                      }}
                      options={optionsDrapery}
                    />
                  </div>
                </div>
                <div className="box50 radio_style">
                  <div className="same_row_selection_title">{t("Sheer Hardware")}</div>
                </div>
                <div className="box50 radio_style">
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={draperySheerPlaceholder}
                      portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedSheer}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdown props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setCart("hardwareSheer", selected[0].value);
                          setDeps("", "86", 1);
                          let tempExtended = extendedTitle;
                          tempExtended["8"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Sheer Hardware")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                              </span>
                            </li>
                          );
                          setExtendedTitle(tempExtended);
                          setSelectedSheer(selected);
                        }
                      }}
                      options={sheerDrapery}
                    />
                  </div>
                </div>
                <div className={step2B !== "None" ? "box50 radio_style" : "noDisplay"}>
                  <div className="same_row_selection_title">{t("Privacy Layer Hardware")}</div>
                </div>
                <div
                  className={step2B !== "None" && step2C !== "" ? "box50 radio_style" : "noDisplay"}
                >
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={draperyLayerPlaceholder}
                      portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedPrivacyLayer}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdown props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setCart("hardwarePrivacyLayer", selected[0].value);
                          setDeps("", "87", 1);
                          let tempExtended = extendedTitle;
                          tempExtended["8"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Privacy Layer Hardware")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                              </span>
                            </li>
                          );
                          setExtendedTitle(tempExtended);
                          setSelectedPrivacyLayer(selected);
                        }
                      }}
                      options={layerDrapery}
                    />
                  </div>
                </div>
                <div
                  className={step2B !== "None" && step2C === "" ? "box50 radio_style" : "noDisplay"}
                >
                  <div className="checkbox_text_info_container">
                    <div className="card-body-display-flex">
                      <span className="checkbox_text">{t("pl_hs_incomplete2")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={
                  step6CHead9 === "Rod" &&
                  step6CHead === "Rod" &&
                  step8RodCheck !== "" &&
                  (step8RodCheck === "2201" || step8RodCheck === "2202" || step8RodCheck === "2203")
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title">{t("Baton Option")}</p>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("None")}
                    value="1"
                    name="step8A4"
                    ref-num="8"
                    id="8A313"
                    checked={step8A4 === "None"}
                    onChange={(e) => {
                      setStep8A4("None");
                      if(step8 === "Same Hardware For All Curtains"){
                        setDeps("", "813", 1);
                      }else{
                        setDeps("", "83");
                      }
                      
                      setCart("BatonOptionA", "None");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("None")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A313"] = ref)}
                  />
                  <label htmlFor="8A313">{t("None")}</label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 30cm")}
                    value="2"
                    name="step8A4"
                    ref-num="8"
                    id="8A321"
                    checked={step8A4 === "Baton 30cm"}
                    onChange={(e) => {
                      setStep8A4("Baton 30cm");
                      if(step8 === "Same Hardware For All Curtains"){
                        setDeps("", "813", 1);
                      }else{
                        setDeps("", "83" , 1);
                      }
                      setCart("BatonOptionA", "Baton 30cm");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 30cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A321"] = ref)}
                  />
                  <label htmlFor="8A321">
                    {t("Baton 30cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["58"]
                          ? GetPrice(
                              modelAccessories["27"]["58"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 45cm")}
                    value="3"
                    name="step8A4"
                    ref-num="8"
                    id="8A331"
                    checked={step8A4 === "Baton 45cm"}
                    onChange={(e) => {
                      setStep8A4("Baton 45cm");
                      if(step8 === "Same Hardware For All Curtains"){
                        setDeps("", "813", 1);
                      }else{
                        setDeps("", "83" ,1);
                      }
                     
                      setCart("BatonOptionA", "Baton 45cm");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 45cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A331"] = ref)}
                  />
                  <label htmlFor="8A331">
                    {t("Baton 45cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["59"]
                          ? GetPrice(
                              modelAccessories["27"]["59"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
              </div>

            
               <div
                className={
                  step8DTrack === "2207" && step8 === "Same Hardware For All Curtains"
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title">{t("Control Position")}</p>
                </div>
                <div className="box33 radio_style">
                  <div className="width_max">
                    <img
                      src={require("../../Images/drapery/grommet/cp_hardware_left.svg").default}
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      className="radio"
                      type="radio"
                      text={t("Left")}
                      value="5"
                      name="step8B4"
                      ref-num="8"
                      id="8B351"
                      checked={step8B4 === "Left"}
                      onChange={(e) => {
                        setStep8B4("Left");
                        if(step8 === "Same Hardware For All Curtains"){
                          setDeps("", "8,8A,8A1,8B,8B1,8B2,8C,8C1,8C2,8C3");
                        }else{
                          setDeps("", "8B3,8C3", 1);
                        }
                        
                        setCart("ControlPositionB", "Left Control");
                        selectChanged(e);
                        let tempExtended = extendedTitle;
                        tempExtended["8"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">{t("Left")}</span>
                          </li>
                        );
                        setExtendedTitle(tempExtended);
                      }}
                      ref={(ref) => (inputs.current["8B351"] = ref)}
                    />
                    <label htmlFor="8B351">{t("Left")}</label>
                  </div>
                </div>
                <div className="box33 radio_style">
                  <div className="width_max">
                    <img
                      src={require("../../Images/drapery/grommet/cp_hardware_right.svg").default}
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      className="radio"
                      type="radio"
                      text={t("Right")}
                      value="6"
                      name="step8B4"
                      ref-num="8"
                      id="8B361"
                      checked={step8B4 === "Right"}
                      onChange={(e) => {
                        setStep8B4("Right");
                        if(step8 === "Same Hardware For All Curtains"){
                          setDeps("", "8,8A,8A1,8B,8B1,8B2,8C,8C1,8C2,8C3");
                        }else{
                          setDeps("", "8B3,8C3", 1);
                        }
                        setCart("ControlPositionB", "Right Control");
                        selectChanged(e);
                        let tempExtended = extendedTitle;
                        tempExtended["8"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">{t("Right")}</span>
                          </li>
                        );
                        setExtendedTitle(tempExtended);
                      }}
                      ref={(ref) => (inputs.current["8B361"] = ref)}
                    />
                    <label htmlFor="8B361">{t("Right")}</label>
                  </div>
                </div>
              </div>
            </div>
            <NextStep currentStep="8" eventKey={hardwareNextStep}>
              {t("NEXT STEP")}
            </NextStep>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
